

import React from 'react';
import { 
  Paper,
  Grid,
  useTheme
} from '@mui/material';
import { 
  Water,
  Speed,
  Opacity,
  Power,
  DeviceThermostat,
  AvTimer
} from '@mui/icons-material';
import ParameterItem from './ParameterItem';
import SectionHeader from './SectionHeader';
import { useAuth } from '../../../AuthContext';

const PumpPerformance = ({ sx }) => {
  const { data ,isOnline,pumpStats} = useAuth();
  const theme = useTheme();

  return (
    <Paper sx={{ 
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      ...sx
    }}>
      <SectionHeader icon={<Water fontSize="small" />} title="Pump Performance" />
      
      <Grid container spacing={1.5} sx={{ 
        p: 2,
        flex: 1,
        alignContent: 'flex-start'
      }}>
        <ParameterItem 
          icon={<Speed />} 
          name="Status" 
          value={data?.pump_running ? "Running" : "Stopped"} 
        />
        {/* <ParameterItem 
          icon={<Speed />} 
          name="RPM" 
          value={data?.rpm || '--'} 
        /> */}
        {/* <ParameterItem 
          icon={<Opacity />} 
          name="Flow Rate" 
          value="120" 
          unit="L/min" 
        /> */}
        {/* <ParameterItem 
          icon={<Water />} 
          name="Total Water Discharge" 
          value={data?.water_discharge || '--'} 
          unit="L" 
        /> */}
        {/* <ParameterItem 
          icon={<Power />} 
          name="Power" 
          value={isOnline?data?.power:'--' || "--"} 
          unit="kW" 
        /> */}
        {/* <ParameterItem 
          icon={<DeviceThermostat />} 
          name="Pressure" 
          value="2.4" 
          unit="bar" 
        /> */}
        <ParameterItem
          icon={<AvTimer />}
          name="Today Running Time"
          value={(pumpStats?.pump_aggregates?.today_running_time ?? 0).toFixed(0)}
          unit="min"
        />
        <ParameterItem
          icon={<AvTimer />}
          name="Today Water Discharged"
          value={(pumpStats?.pump_aggregates?.today_water_discharge ?? 0).toFixed(2)}
          unit="L"
        />
       
        {/* <Grid item xs={12} sx={{ mt: 'auto' }}>
          <ParameterItem 
            icon={<Speed />} 
            name="Pump Performance Metrics" 
            value="" 
            sx={{ height: 120 }}
          />
        </Grid> */}
      </Grid>
    </Paper>
  );
};

export default PumpPerformance